import {AlertService} from '../../shared/services/alert.service';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import {Assessment} from "../../shared/models/assessment";
import {Scale} from "../../shared/models/scale";
import {AssessmentService} from "../../shared/services/assessment.service";

@Component({
  selector: 'app-scale-new',
  templateUrl: './scale-new.component.html',
  styleUrls: ['./scale-new.component.css']
})
export class ScaleNewComponent implements OnInit {

  private _scale:Scale;
  private _assessment:Assessment;

  constructor(private _assessmentService:AssessmentService
    ,private alertService:AlertService
   ,private route:ActivatedRoute
    ,private router:Router) { 
    this._scale = new Scale();
    this._scale.name = "Untitled";
    this._scale.id = this._assessmentService.newId();
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      let assessmentUid = params['uid'];
      this._assessmentService.getAssessment(assessmentUid)
        .then((assessment:Assessment) => {
          this._assessment = assessment;
        })
        .catch((error) => {
          console.error(error);
        })
    });
  }

  get scale() {
    return this._scale;
  }

  set scale(v:Scale) {
    this._scale = v;
  }

  save() {
    this._assessment.addScale(this.scale);
		
		this._assessmentService.saveAssessment(this._assessment).then(() => {
      this.alertService.success("Scale Saved!");
      setTimeout(() => {
        this.router.navigate(["../", this.scale.id, "edit"], {relativeTo: this.route, replaceUrl: true});
      }, 1500);
    }).catch((error) => {
      this.alertService.error("Error occurred in saving. Please try again.");
      console.error(error);
		});
	}
	
	saveAndCreateNew() {
    this._assessment.addScale(this.scale);
		
		this._assessmentService.saveAssessment(this._assessment).then((assessment) => {
        this.alertService.success("Scale Saved!");
				this.scale =  new Scale();
				this.scale.id = this._assessmentService.newId();
    })
    .catch((error) => {
      console.log(error);
      this.alertService.error("Error occurred in saving. Please try again.");
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/admin/scale-new/scale-new.component.ts